import { AddToBagModalEnum } from '@inter-ikea-kompis/component-add-to-bag';
import { BuyInStoreModalEnum } from '@inter-ikea-kompis/component-buy-in-store';
import { FinancialServicesModalEnum } from '@inter-ikea-kompis/component-financial-services';
import { PriceModuleModalEnum } from '@inter-ikea-kompis/component-price-module';
import { SaveDesignToProfileModalEnum } from '@inter-ikea-kompis/component-save-design-to-profile';

enum ComponentUniqueEnum {
	confirmationCard = 'confirmationCard'
}

enum ShareDesignCardEnum {
	shareDesignCard = 'shareDesignCard'
}

enum ConfigurationSummaryModalEnum {
	confirmationCard = ComponentUniqueEnum.confirmationCard,
	ecoFeeCard = PriceModuleModalEnum.ecoFeeCard,
	energyFicheCard = PriceModuleModalEnum.energyFicheCard,
	energyLabelCard = PriceModuleModalEnum.energyLabelCard,
	unavailableProductCard = AddToBagModalEnum.unavailableProductCard,
	financialServicesCard = FinancialServicesModalEnum.financialServicesCard,
	saveDesignToProfileCard = SaveDesignToProfileModalEnum.saveDesignToProfileCard,
	shareDesignCard = ShareDesignCardEnum.shareDesignCard,
	buyInStore = BuyInStoreModalEnum.buyInStore
}

export default ConfigurationSummaryModalEnum;
